import React, { useEffect, Suspense, lazy } from "react";

import Navbar from "./../components/Navbar";
import ScrollTopButton from "../components/ScrollTopButton";
import LazyLoad from "../components/LazyLoad";
import AOS from "aos";
import "aos/dist/aos.css";

// Skeletons
import ProposSkeleton from "../components/skeletons/ProposSkeleton";
import NosServicesSkeleton from "../components/skeletons/NosServicesSkeleton";
import CuisineSkeleton from "../components/skeletons/CuisineSkeleton";

// Lazy Loaded Components
const HeroSlider = lazy(() => import("../components/HeroSlider"));
const Propos = lazy(() => import("../components/Propos"));
const Catalogs = lazy(() => import("../components/Catalogues"));
const ServicesSlider = lazy(() => import("../components/NosServices"));
const NosProduits = lazy(() => import("../components/NosProduits"));
const Footer = lazy(() => import("../components/Footer"));
const Cuisine = lazy(() => import("../components/Cuisine"));

function HomePage() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="overflow-hidden">
      <Navbar />

      <div className="bg-[#F6F6F6]">
        <div className="my-10">
            <HeroSlider />
        </div>

        <div className="max-w-[112.5rem] mx-auto " data-aos="fade-up">
          <LazyLoad fallback={<ProposSkeleton />}>
            <Suspense fallback={<ProposSkeleton />}>
              <Propos />
            </Suspense>
          </LazyLoad>
        </div>

        <div className="my-10" data-aos="fade-up">
          <LazyLoad fallback={<CuisineSkeleton />}>
            <Suspense fallback={<CuisineSkeleton />}>
              <Cuisine />
            </Suspense>
          </LazyLoad>
        </div>

        <div className="max-w-[112.5rem] mx-auto">
          <div className="my-10" data-aos="fade-up">
                <Catalogs />
          </div>

          <div className="" data-aos="fade-up">
            <LazyLoad fallback={<NosServicesSkeleton />}>
              <Suspense fallback={<NosServicesSkeleton />}>
                <ServicesSlider />
              </Suspense>
            </LazyLoad>
          </div>
        </div>
        <div className="my-10" data-aos="fade-up">
              <NosProduits />
        </div>
            <Footer />
        <ScrollTopButton />
      </div>
    </div>
  );
}

export default HomePage;
